import React from "react";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useMailMessages } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { MailDirection } from "../../../__generated__/globalTypes";

interface IProps {
  customerId?: number;
}

export const MailMessagesList: React.FC<IProps> = ({ customerId }) => {
  const { data, loading } = useMailMessages({ where: { customerId } });

  if (loading) return <Loading />;

  if (!data?.mailMessages?.results?.length) {
    return <EmptyList text="Aucun email" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>&nbsp;</TableCell>
          <TableCell header>Sujet</TableCell>
          <TableCell header>De</TableCell>
          <TableCell header>À</TableCell>
          {!customerId && <TableCell header>Client</TableCell>}
          <TableCell header>Date</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.mailMessages?.results?.map((message) => (
          <TableRow key={`mail-message-${message.id}`} hover={false}>
            <TableCell>
              {message.direction === MailDirection.Incoming ? (
                <ArrowDownLeft className="w-4 h-4 text-blue-600" />
              ) : (
                <ArrowUpRight className="w-4 h-4 text-green-600" />
              )}
            </TableCell>
            <TableCell className="max-w-xs truncate">{message.subject}</TableCell>
            <TableCell className="max-w-[160px] truncate">{message.fromAddress}</TableCell>
            <TableCell className="max-w-[160px] truncate">{message.toAddresses}</TableCell>
            {!customerId && <TableCell>{message.customer?.name ?? "-"}</TableCell>}
            <TableCell>{formatDisplayDate(message.sentAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
